import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { StrictDict, useKeyedState } from '@edx/react-unit-test-utils';
import { useModel } from '@src/generic/model-store';
import { useIntl } from '@edx/frontend-platform/i18n';
import { getLocalStorage } from '@src/data/localStorage';

import messages from './messages';
import SVGLoader from './SVGLoader';
import './index.scss';

export const selectedLanguageKey = 'selectedLanguages';
export const stateKeys = StrictDict({
  selectedLanguage: 'selectedLanguage',
});

export const LONG_LOADING_DELAY_MS = 2000;

const TranslationsLoader = ({ courseId, defaultLoaderComponent }) => {
  const { formatMessage } = useIntl();
  const { language } = useModel('coursewareMeta', courseId);
  const courseLanguage = language || 'en';
  const selectedLanguageItem = getLocalStorage(selectedLanguageKey) || {};
  const [selectedLanguage] = useKeyedState(
    stateKeys.selectedLanguage,
    selectedLanguageItem[courseId] || courseLanguage,
  );

  const [showAdditionalMessage, setShowAdditionalMessage] = useState(false);

  useEffect(() => {
    if (courseLanguage !== selectedLanguage) {
      const timer = setTimeout(() => {
        setShowAdditionalMessage(true);
      }, LONG_LOADING_DELAY_MS);

      return () => clearTimeout(timer);
    }
    return undefined; // to remove linting error
  }, [courseLanguage, selectedLanguage]);

  return courseLanguage !== selectedLanguage ? (
    <div
      className="d-flex justify-content-center align-items-center flex-column"
      id="translating-loader-container"
    >
      <SVGLoader />
      <p className="mt-2" id="loader-text">
        {formatMessage(messages.translatingLoaderText)}
        <span className="ellipsis-container">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </p>
      {showAdditionalMessage && (
        <p className="mt-2" id="additional-message">
          {formatMessage(messages.translatingLoaderAdditionalTextFirstLine)} <br />
          {formatMessage(messages.translatingLoaderAdditionalTextWaitNote)}
        </p>
      )}
    </div>
  ) : (
    defaultLoaderComponent
  );
};

TranslationsLoader.propTypes = {
  courseId: PropTypes.string.isRequired,
  defaultLoaderComponent: PropTypes.node.isRequired,
};

export default TranslationsLoader;
